<!-- Large Screen Version (LG) - No changes needed, perfect as is -->
<div class="tw-hidden lg:tw-block tw-w-full tw-px-[10px] sm:tw-px-[20px]">
    <div class="tw-grid tw-grid-cols-1 tw-gap-[15px]">
        <div
            *ngFor="let item of getStartedItems"
            class="tw-flex tw-flex-row tw-gap-[15px] tw-items-stretch tw-p-[20px] tw-bg-[#ECF0F0] tw-rounded-[15px] tw-shadow-sm tw-min-h-[227px]"
        >
            <!-- Icon -->
            <div
                class="tw-p-[10px] tw-flex tw-justify-center tw-items-center tw-flex-shrink-0"
            >
                <img
                    [src]="item.image"
                    [alt]="item.title"
                    class="tw-w-[75px] tw-h-[75px] tw-object-contain"
                />
            </div>

            <!-- Content -->
            <div class="tw-flex tw-flex-col tw-gap-[10px] tw-flex-1">
                <span
                    class="tw-text-[16px] tw-font-bold tw-leading-[22px] tw-text-[#1A202C]"
                >
                    {{ item.title }}
                </span>
                <span
                    class="tw-text-[14px] tw-font-normal tw-leading-[20px] tw-text-[#1A202C] default-html"
                    [innerHTML]="item.description"
                >
                </span>
            </div>
        </div>
    </div>
</div>

<!-- Medium Screen Version (MD) - Carousel with 1 item per scroll, horizontal layout -->
<div class="tw-hidden md:tw-block lg:tw-hidden tw-w-full tw-px-[20px]">
    <p-carousel
        [value]="getStartedItems"
        [numVisible]="1"
        [numScroll]="1"
        [circular]="true"
        [showNavigators]="false"
        [showIndicators]="true"
        [autoplayInterval]="15000"
        contentClass="md-get-started-carousel"
    >
        <ng-template let-item pTemplate="item">
            <div
                class="tw-flex tw-flex-row tw-gap-[15px] tw-items-stretch tw-p-[20px] tw-bg-[#ECF0F0] tw-rounded-[15px] tw-shadow-sm tw-min-h-[210px] tw-w-full tw-max-w-full tw-box-border"
            >
                <!-- Icon -->
                <div
                    class="tw-p-[10px] tw-flex tw-justify-center tw-items-center tw-flex-shrink-0"
                >
                    <img
                        [src]="item.image"
                        [alt]="item.title"
                        class="tw-w-[65px] tw-h-[65px] tw-object-contain"
                    />
                </div>

                <!-- Content -->
                <div
                    class="tw-flex tw-flex-col tw-gap-[10px] tw-flex-1 tw-justify-center tw-items-start"
                >
                    <span
                        class="tw-text-[15px] tw-font-bold tw-leading-[22px] tw-text-[#1A202C]"
                    >
                        {{ item.title }}
                    </span>
                    <span
                        class="tw-text-[13px] tw-font-normal tw-leading-[19px] tw-text-[#1A202C]"
                    >
                        {{ item.description }}
                    </span>
                </div>
            </div>
        </ng-template>
    </p-carousel>
</div>

<!-- Small Screen Version (SM) - Carousel with peek view, horizontal layout -->
<div class="tw-block md:tw-hidden tw-w-full tw-overflow-hidden">
    <div class="tw-px-[10px]">
        <p-carousel
            [value]="getStartedItems"
            [numVisible]="1.3"
            [numScroll]="1"
            [circular]="false"
            [showNavigators]="false"
            [showIndicators]="true"
            [autoplayInterval]="15000"
            contentClass="mobile-get-started-carousel"
        >
            <ng-template let-item pTemplate="item">
                <div
                    class="tw-bg-[#ECF0F0] tw-rounded-[15px] tw-py-[35px] tw-px-[15px] tw-flex tw-flex-col tw-gap-[10px] tw-items-center tw-min-h-[200px] tw-h-full tw-w-full"
                >
                    <!-- Icon -->
                    <div
                        class="tw-flex tw-justify-center tw-items-center tw-flex-shrink-0"
                    >
                        <img
                            [src]="item.image"
                            [alt]="item.title + ' Image'"
                            class="tw-w-[50px] tw-h-[50px] tw-object-contain"
                        />
                    </div>

                    <!-- Content -->
                    <div
                        class="tw-flex tw-flex-col tw-gap-[8px] tw-flex-1 tw-items-center tw-justify-start"
                    >
                        <span
                            class="tw-text-[14px] tw-font-bold tw-leading-[20px] tw-text-[#1A202C] tw-text-center"
                        >
                            {{ item.title }}
                        </span>
                        <span
                            [innerHTML]="item.description"
                            class="tw-text-[12px] tw-font-normal tw-leading-[18px] tw-text-[#1A202C] tw-text-center default-html"
                        >
                        </span>
                    </div>
                </div>
            </ng-template>
        </p-carousel>
    </div>
</div>
